export default "__VITE_ASSET__C0HpaCv9__"